export default __webpack_public_path__ + "static/company-profile-9ce08cc4b54c5cd57cb746712e75cb05.pdf";